import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import {
  PlatesProcessInternalUserResponse,
  PostSalePlatesProcess,
  VinsFromLeadResponse,
} from "../interfaces/plates-process.interface";

@Injectable()
export class PlatesProcessService {
  constructor(private http: HttpClientService) {}

  public get(id): Observable<any[]> {
    return this.http.get("/api/plates_process/" + id).pipe(tap((_) => console.log("PlatesProcessService.get: Ok.")));
  }

  public put(plates_process): Observable<any[]> {
    let options = {
      plates_process,
    };
    return this.http
      .put("/api/plates_process/" + plates_process.id, options)
      .pipe(tap((_) => console.log("PlatesProcessService.put: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/plates_process/" + id)
      .pipe(tap((_) => console.log("PlatesProcessService.delete: Ok.")));
  }

  public dashboard(filters): Observable<any> {
    const options = {
      params: filters,
    };
    return this.http
      .get("/api/plates_process/dashboard", options)
      .pipe(tap((_) => console.log("PlatesProcessService.dashboard: Ok.")));
  }

  public exportCsv(filters: any): Observable<Blob> {
    const options = {
      params: filters,
      responseType: "blob" as "json",
    };
    return this.http
      .get("/api/plates_process/export_csv", options)
      .pipe(tap((_) => console.log("PlatesProcessService.exportCsv: Ok.")));
  }

  public getProviders(id): Observable<any> {
    return this.http
      .get(`/api/plates_process/${id}/providers`)
      .pipe(tap((_) => console.log("PlatesProcessService.getProviders: Ok")));
  }

  public getInstallationAppointments(): Observable<any[]> {
    return this.http
      .get("/api/plates_process/appointments")
      .pipe(tap((_) => console.log("PlatesProcessService.getInstallationAppointments: Ok.")));
  }

  public startEarlyInstallation(search_key): Observable<any[]> {
    const options = {
      params: {
        search_key,
      },
    };
    return this.http
      .get("/api/plates_process/start_early_installation", options)
      .pipe(tap((_) => console.log("PlatesProcessService.startEarlyInstallation: Ok.")));
  }

  public filterById(person_id, dashboard_type): Observable<any> {
    const params = {
      person_id,
      dashboard_type,
    };
    return this.http
      .post("/api/plates_process/filter_by_id", params)
      .pipe(tap((_) => console.log("PlatesProcessService.filterById: Ok.")));
  }

  public updatePlatesType(id: number, platesType: string): Observable<any> {
    const payload = { plates_type: platesType };
    return this.http
      .put(`/api/plates_process/${id}`, payload)
      .pipe(tap((_) => console.log("PlatesProcessService.updatePlatesType: Ok.")));
  }

  public updatePlatesProcessState(id: number, state_id: number): Observable<any> {
    const payload = { estado_id: state_id };
    return this.http
      .put(`/api/plates_process/${id}`, payload)
      .pipe(tap((_) => console.log("PlatesProcessService.updatePlatesProcessState: Ok.")));
  }

  public markAsCompleted(plates_process): Observable<any[]> {
    const payload = { plates_process: { stage: "completed" } };
    return this.http
      .put(`/api/plates_process/${plates_process.id}`, payload)
      .pipe(tap((_) => console.log("PlatesProcessService.markAsCompleted: Ok.")));
  }

  public saveRequiredDocuments(
    platesProcessId: string,
    selectedDocuments: string[],
    additionalDocuments: string[],
    physicalDocuments: string[],
    docsDeliveryMaxDays: number,
    docsDeliverySendDate: string
  ) {
    return this.http
      .post("/api/plates_process/save_required_documents", {
        plates_process_id: platesProcessId,
        required_documents: selectedDocuments,
        additional_documents: additionalDocuments,
        physical_documents: physicalDocuments,
        docs_delivery_max_days: docsDeliveryMaxDays,
        docs_delivery_send_date: docsDeliverySendDate,
      })
      .pipe(tap((_) => console.log("PlatesProcessService.saveRequiredDocuments: Ok.")));
  }

  public createPostSale(plates_process: PostSalePlatesProcess): Observable<any[]> {
    const options = {
      plates_process,
    };
    return this.http
      .post(`/api/plates_process/create_postsale`, options)
      .pipe(tap((_) => console.log("PlatesProcessService.updateManualProcessInfo: Ok.")));
  }
  public fetchVinsFromLead(lead: number): Observable<VinsFromLeadResponse> {
    return this.http
      .get(`/api/plates_process/${lead}/fetch_vins_from_lead`, {})
      .pipe(tap((_) => console.log("PlatesProcessService.fetchVinsFromLead: Ok.")));
  }
  public markProviderActivity(id): Observable<any[]> {
    return this.http
      .put(`/api/plates_process/${id}/mark_provider_activity`, {})
      .pipe(tap((_) => console.log("PlatesProcessService.markProviderActivity.put: Ok.")));
  }
  public notifyUploadToPlates(id, current_user, doc): Observable<any[]> {
    const options = {
      file_name: doc.original_filename,
      uploaded_at: doc.created_at,
      uploaded_by: {
        id: current_user.id,
        full_name: `${current_user.full_name}`,
        email: current_user.email,
      },
      document_id: doc.id,
      category_name: doc.category_name,
    };

    return this.http
      .post(`/api/plates_process/${id}/notify_document_upload`, options)
      .pipe(tap((_) => console.log("PlatesProcessService.sendUploadNotificationToOperations.post: Ok.")));
  }

  public setInitialStage(id: number): Observable<any[]> {
    return this.http
      .put(`/api/plates_process/${id}/set_initial_stage`, {})
      .pipe(tap((_) => console.log("PlatesProcessService.setInitialStage: Ok.")));
  }
}
